<script setup>
import { ref, computed } from 'vue'
import Button from '@components/forms/Button.vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const error = computed(() => {
	return errors.value[route.meta?.type ?? route.params?.type]
})

const errors = ref({
	404: {
		icon: 'fa-solid fa-ban',
		title: '404 - Page Not Found',
		description: 'The page you are looking for does not exist.',
	},
	auth: {
		icon: 'fa-solid fa-exclamation-triangle',
		title: 'Authentication Error',
		description: 'There has been an error during the authentication process. Please try again later.',
	},
	'auth-no-email': {
		icon: 'fa-solid fa-envelope-circle-check',
		title: 'Email Required',
		description:
			"We couldn't get an email address from your Logitech account. Please make sure your Logitech account has a verified email address and try signing in again.",
	},
	'auth-email-conflict': {
		icon: 'fa-solid fa-user-group',
		title: 'Account Conflict',
		description:
			'This email is already linked to a different Logitech account. Please sign in with the original Logitech account that owns this email, or contact support if you need help.',
	},
})
</script>

<template>
	<section class="flex h-[calc(100vh-308px)] min-h-56 items-center justify-center bg-gradient-to-bl from-logi-grey-600 via-black to-black">
		<div class="container">
			<div class="flex h-full w-full flex-col items-center justify-center">
				<div class="flex w-full max-w-screen-sm flex-col overflow-y-auto rounded-md bg-logi-grey-900 p-5" v-if="error">
					<div class="flex flex-col gap-5">
						<div class="flex items-center gap-3">
							<div class="flex size-8 min-w-8 items-center justify-center rounded-full bg-logi-blue-500">
								<i :class="['text-lg text-black', error.icon]" />
							</div>
							<h5>{{ error.title }}</h5>
						</div>
						<p class="text-white/60">{{ error.description }}</p>
						<Button class="solid secondary thin" icon-left="fas fa-arrow-left" :to="{ name: 'index' }">Back to Home</Button>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
